/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages

                // HAMBURGER MENU
                // --------------
                //$('.m-hamburger').click(function() {
                //	$(this).toggleClass('is-open');
                //});




                // p: abilita il responsive menu
                /*
        		var nav = responsiveNav(".responsive-nav", {
        		  customToggle: "nav-toggle"
        		});
                */


                // p: abilita lo slick slider se necessario
                /*
        		$('.slick').slick({
        		  autoplay: true,
        		  //lazyLoad: 'ondemand',
        		  slidesToShow: 1,
        		  slidesToScroll: 1,
        		  fade: true,
        		  arrows: false,
        		  dots: false,
        		  mobileFirst: true, 
                  centerMode: true,
                  centerPadding: '0px',
        		  responsive: [
        		      {
        		        breakpoint: 850,
        		        settings: {
        		          dots: true
        		        }
        		      }
        		  ]
        		});
                */ 

                // p: abilita il lightbox / galleria se necessario
                /*
        		$('.js-gallery').each(function() { // the containers for all your galleries
				    $(this).magnificPopup({
				        delegate: 'a', // the selector for gallery item
				        type: 'image',
				        gallery: {
				          enabled:true
				        }
				    });
				});
                */

                // mgigli - lightbox per il video
                /*
        		$('.js-video').each(function() { // the containers for all your galleries
				    $(this).magnificPopup({
				        delegate: 'a', // the selector for gallery item
				        type: 'iframe',
				    });
				});
                */

                // p: abilita lo slick slider per la tabella prezzi 
                $('.js-tabella-prezzi-slick').slick({
                    autoplay: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    mobileFirst:true,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 1023,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });

                // mgigli: abilita lo slick slider per la tabella sconti
                $('.js-tabella-sconti-slick').slick({
                    autoplay: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    mobileFirst:true,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 1023,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });


                // mgigli - ADD DATA-VALIDATION ATTRIBUTES TO FORM PRENOTAZIONE
                // ------------------------------------------------------------
                $('.form-prenota [type=text].required').attr('data-validation', 'required');
                $('.form-prenota [type=email].required').attr('data-validation', 'email');
                $('.form-prenota [type=url].required').attr('data-validation', 'url');
                $('.form-prenota [type=tel].required').attr('data-validation', 'number');
                $('.form-prenota [type=number].required').attr('data-validation', 'number');
                $('.form-prenota [type=date].required').attr('data-validation', 'date');
                $('.form-prenota textarea.required').attr('data-validation', 'required');
                $('.form-prenota select.required').attr('data-validation', 'required');
                $('.form-prenota input[type=checkbox].required').attr('data-validation', 'required');
                $('.form-prenota [type=file].required').attr('data-validation', 'required');

                // ADD DATA-VALIDATION ATTRIBUTES TO CF7 INPUT
                // -------------------------------------------
                $('.wpcf7-validates-as-required[type=text]').attr('data-validation', 'required');

                $('.wpcf7-validates-as-required[type=email]').attr('data-validation', 'email');

                $('.wpcf7-validates-as-required[type=url]').attr('data-validation', 'url');

                $('.wpcf7-validates-as-required[type=tel]').attr('data-validation', 'number');

                $('.wpcf7-validates-as-required[type=number]').attr('data-validation', 'number');

                $('.wpcf7-validates-as-required[type=date]').attr('data-validation', 'date');

                $('textarea.wpcf7-validates-as-required').attr('data-validation', 'required');

                $('select.wpcf7-validates-as-required').attr('data-validation', 'required');

                $('.wpcf7-validates-as-required input[type=checkbox]').attr('data-validation', 'required');
                $('.wpcf7-validates-as-required[type=checkbox]').attr('data-validation', 'required');

                $('.wpcf7-validates-as-required[type=file]').attr('data-validation', 'required');


                // INIT JQUERY FORM VALIDATOR
                // --------------------------
                var ita = {
                    errorTitle : 'Invio della richiesta fallito!',
                    requiredFields : 'Questo campo è obbligatorio',
                    badTime : 'Non hai inserito un orario corretto',
                    badEmail : 'L\'indirizzo email non è corretto',
                    badTelephone : 'Non hai inserito un numero di telefono corretto',
                    badSecurityAnswer : 'Non hai dato una risposta esatta alla domanda di sicurezza',
                    badDate : 'Non hai inserito una data corretta',
                    lengthBadStart : 'Devi inserire una risposta tra ',
                    lengthBadEnd : ' caratteri',
                    lengthTooLongStart : 'Non hai dato una risposta più lunga di ',
                    lengthTooShortStart : 'Non hai dato una risposta più corta di ',
                    notConfirmed : 'I valori non possono essere confermati',
                    badDomain : 'Valore di dominio non corretto',
                    badUrl : 'La tua risposta non è un URL corretto',
                    badCustomVal : 'Hai dato una risposta non corretts',
                    badInt : 'La risposta che hai dato non è un numero corretto',
                    badSecurityNumber : 'Il tuo numero di sicurezza non è corretto',
                    badUKVatAnswer : 'Numero UK VAT non corretto',
                    badStrength : 'La password non è abbastanza sicura',
                    badNumberOfSelectedOptionsStart : 'Devi scegliere almeno ',
                    badNumberOfSelectedOptionsEnd : ' risposte',
                    badAlphaNumeric : 'La risposta deve contenere solo caratteri alfanumerici ',
                    badAlphaNumericExtra: ' e ',
                    wrongFileSize : 'Il file che vuoi caricare è troppo grande',
                    wrongFileType : 'Il file che vuoi caricare non è del tipo corretto',
                    groupCheckedRangeStart : 'Scegli tra ',
                    groupCheckedTooFewStart : 'Scegli almeno ',
                    groupCheckedTooManyStart : 'Scegli un massimo di ',
                    groupCheckedEnd : ' campo/i'
                };
                var deu = {
                    requiredFields : 'Das ist ein Pflichtfeld',
                    badEmail : 'Die E-Mail Adresse ist nicht korrekt',
                };

                var formPrenotaGo = false;
                $(document).on('submit', 'form.form-prenota', function(e) {
                    if (! formPrenotaGo) {
                        e.preventDefault();
                        formPrenotaGo = true;

                        // mgigli 20230222 - Tracciamento motorino di ricerca GA4
                        // rif. https://docs.google.com/spreadsheets/d/19M24bYbdBJOB4Eku39IbFLGV_AxI30pjWGZDPDucJmw/edit#gid=544312610
                        var form = $(this);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({'event': 'begin_structure_research'});
                        window.dataLayer.push({'destination': form.find('[name="localita"] option:selected').text()});
                        window.dataLayer.push({'guests_number': form.find('[name="persone"]').val()});
                        window.dataLayer.push({'start_date': form.find('[name="arrivo"]').attr('data-dategmy')});
                        window.dataLayer.push({'end_date': form.find('[name="partenza"]').attr('data-dategmy')});
                        window.dataLayer.push({'special_offer': form.find('[name="offspec"]').prop('checked')});
                        window.dataLayer.push({'premium_structures': form.find('[name="FDC_INCL"]').prop('checked')});

                        //console.log('submit');
                        //console.log(window.dataLayer);
                        
                        setTimeout(function() { $('form.form-prenota').submit(); }, 1000);
                    }
                });

                if( $('html').attr('lang')==='it-IT' ) {
                    $.validate({
                        language: ita,
                        borderColorOnError : '',
                        scrollToTopOnError : false,
                        onSuccess : function(form) {
                            // Form Prenota
                            if (form.hasClass('form-prenota')) {
                                form.find('[name="datetimerange"]').prop('disabled', true);
                                //return false; // Interrompe l'invio della form
                            }
                            // Form CF7
                            else if (form.hasClass('wpcf7-form')) {
                                // mgigli 20220223 - Tracciamento click iscrizione newsletter GA4
                                // rif. https://docs.google.com/spreadsheets/d/19M24bYbdBJOB4Eku39IbFLGV_AxI30pjWGZDPDucJmw/edit#gid=544312610
                                if (form.hasClass('form-newsletter')) {
                                    window.dataLayer.push({'event': 'submit_newsletter_form'});
                                }

                                var thankyouURL = $(form[0]).parents('.wpcf7').next().text();
                                setTimeout(function() { window.location.href = thankyouURL }, 1000);
                                //location.assign(thankyouURL);
                            }
                        },
                        onError : function(form) {
                            // Form Prenota
                            /*
                            if (form.hasClass('form-prenota')) {
                                console.log("form error");
                            }
                            */
                        },
                    });
                } else if( $('html').attr('lang')==='de-DE' ) {
                    $.validate({
                        language: deu,
                        borderColorOnError : '',
                        scrollToTopOnError : false,
                        onSuccess : function(form) {
                            // Form Prenota
                            if (form.hasClass('form-prenota')) {
                                form.find('[name="datetimerange"]').prop('disabled', true);
                            }
                            // Form CF7
                            else if (form.hasClass('wpcf7-form')) {
                                // mgigli 20220223 - Tracciamento click iscrizione newsletter GA4
                                // rif. https://docs.google.com/spreadsheets/d/19M24bYbdBJOB4Eku39IbFLGV_AxI30pjWGZDPDucJmw/edit#gid=544312610
                                if (form.hasClass('form-newsletter')) {
                                    window.dataLayer.push({'event': 'submit_newsletter_form'});
                                }

                                var thankyouURL = $(form[0]).parents('.wpcf7').next().text();
                                setTimeout(function() { window.location.href = thankyouURL }, 1000);
                                //location.assign(thankyouURL);
                            }
                        },
                    });
                } else {
                    $.validate({
                        borderColorOnError : '',
                        onSuccess : function(form) {
                            // Form Prenota
                            if (form.hasClass('form-prenota')) {
                                form.find('[name="datetimerange"]').prop('disabled', true);
                            }
                            // Form CF7
                            else if (form.hasClass('wpcf7-form')) {
                                // mgigli 20220223 - Tracciamento click iscrizione newsletter GA4
                                // rif. https://docs.google.com/spreadsheets/d/19M24bYbdBJOB4Eku39IbFLGV_AxI30pjWGZDPDucJmw/edit#gid=544312610
                                if (form.hasClass('form-newsletter')) {
                                    window.dataLayer.push({'event': 'submit_newsletter_form'});
                                }

                                var thankyouURL = $(form[0]).parents('.wpcf7').next().text();
                                setTimeout(function() { window.location.href = thankyouURL }, 1000);
                                //location.assign(thankyouURL);
                            }
                        },
                    });
                }

                // INIT AJAXFORM ON CF7 FORMS
                // --------------------------
                $('.wpcf7-form').ajaxForm();

            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        },
        'single-buildings': {
            init: function() {


            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);


    // Language menu (apre/chiude il menu lingue a tendina)
    $('.language-toggle').on('click',function(e){
        e.preventDefault();
        $('.language-menu').toggleClass('is-visible');
    });




    //  Menu mobile 
    $('.nav-toggle').on('click',function(e){
        e.preventDefault();
        $('body').toggleClass('nav-expanded');
    });


    // Language menu (apre/chiude il menu lingue a tendina)
    $('.language-toggle').on('click',function(e){
        e.preventDefault();
        $('.language-menu').toggleClass('is-visible');
    });

    // Accordion

    if($(window).width() < 768){
        var title = document.querySelectorAll('.condominio .accordion__header');
        for(var i = 0; i < title.length; i++) {
            title[i].classList.add('js-header');
            //console.log(title[i].classList);
        }

        var copy = document.querySelectorAll('.condominio .accordion__content');
        for(var i = 0; i < copy.length; i++) {
            copy[i].classList.add('js-content');
            //console.log(copy[i].classList);
        }

        $('.condominio .accordion .js-content').slideUp();
        var $title = $('.condominio .accordion .js-header');
        $title.click(function () {
            $(this).next(copy).slideToggle();
            //$(this).parent().siblings().children().next().slideUp();
            $(this).toggleClass('active');
            //$(this).parent().siblings().children().removeClass('active');
            return false;
        });
    }

    // Accordion faq
    var title = document.querySelectorAll('.faqSection .accordion__header');
    for(var i = 0; i < title.length; i++) {
        title[i].classList.add('js-header');
        //console.log(title[i].classList);
    }

    var copy = document.querySelectorAll('.faqSection .accordion__content');
    for(var i = 0; i < copy.length; i++) {
        copy[i].classList.add('js-content');
        //console.log(copy[i].classList);
    }

    $('.faqSection .accordion .js-content').slideUp();
    var $title = $('.faqSection .accordion .js-header');
    $title.click(function () {
        $(this).next(copy).slideToggle();
        //$(this).parent().siblings().children().next().slideUp();
        $(this).toggleClass('active');
        //$(this).parent().siblings().children().removeClass('active');

         // toggle attributi
         if($(this).attr('aria-expanded') == 'true'){
            $(this).attr('aria-expanded','false');
        }

        else if($(this).attr('aria-expanded') == 'false'){
            $(this).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
        }

        return false;
    });

    var $item = $('.accordion .js-item'); // per la tastiera ridefinisco il selettore perché è l'item ad essere focusable a differenza del clic del mouse cha va sull'header



    $item.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina


        var keyCode = e.keyCode || e.which;


        if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar


            $(this).children(title).next(copy).slideToggle();
            $(this).siblings().children().next().slideUp();
            $(this).children(title).toggleClass('active');

            $(this).siblings().children().removeClass('active');


            if($(this).children(title).attr('aria-expanded') == 'true'){
                $(this).children(title).attr('aria-expanded','false');
            }

            else if($(this).children(title).attr('aria-expanded') == 'false'){
                $(this).children(title).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
            }

            return false;
        }



    });




    // slider eventi < 768px
    if(window.matchMedia) { 

        var mettiSlick = function(sel) {
            if ($(sel+' article').length < 2) {
                $(sel+' article').css('margin', '0 auto');
                return;
            }
            $(sel).slick({
                dots: true,
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                responsive: [
                    {
                        breakpoint: 650,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: true,
                        }
                    },
                    {
                        breakpoint: 450,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                            centerMode: true,
                            //centerPadding: '24px',
                        }
                    }
                ]
            });
        }

        var togliSlick = function(sel) {
            $(sel).slick('unslick');
        }


        var mq = window.matchMedia('(max-width: 767px)');

        if(mq.matches) {
            mettiSlick('.offers-list');
            mettiSlick('.events-list');
        }

        mq.addListener(function(changed) {
            if(changed.matches) {
                mettiSlick('.offers-list');
                mettiSlick('.events-list');
            } else {
                togliSlick('.offers-list');
                togliSlick('.events-list');
            }
        });
    } 



    // gallery

    $('.condominio-img').slickLightbox({
        src: 'href',
        itemSelector: 'div a',
        navigateByKeyboard : true,
        caption: 'caption',
        lazy: true
    });

    $('.condominio-video').slickLightbox();



    /* Menu lingue 
    */


    $('.language-toggle').on('click',function(e){
        e.preventDefault();
        $('.language-menu').toggleClass('is-visible');
    });



    /* Ricerca - old */

    /* $('.search-form button').on('click',function(e){
        e.preventDefault();
        $(".search-site-block").addClass('is-visible'); 
    });

    $('.search-site-block .btn-close').on('click',function(){
        $(".search-site-block").removeClass('is-visible');
    });
 */




    // Pulsanti incremento-decremento quantità


    $(".btn-increase-decrease").on("click", function (e) {
        var $button = $(this);
        var oldValue = $button.parent().find('.quantity').val();
        $button.parent().find('.btn-incr[data-action="decrease"]').removeClass('inactive');
        if ($button.data('action') == "increase") {
            var newVal = parseFloat(oldValue) + 1;
        } else {
            if (oldValue > 1) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 1;
                $button.addClass('inactive');
            }
        }
        $button.parent().find('.quantity').val(newVal);
        e.preventDefault();
    });


    /* Descrizioni strutture */

    $(".js-toggle-more").on("click", function(e) {
        e.preventDefault();         
        $('.hidden-description').toggle();
        $('.accomodations-description').toggleClass('is-full-visible');


        var target =  $('.accomodations-description');

        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top 
            }, 1000);
            return false;
        }
    });






    /*Smooth anchor scroll landing 
   */
    $('a.anchor:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top -170
                }, 600);
                return false;
            }
        }
    });

    // mgigli 20180614 - Gestione cookie

    function createCookie(name,value,days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            var expires = "; expires="+date.toGMTString();
        }
        else var expires = "";
        document.cookie = name+"="+value+expires+"; path=/";
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name,"",-1);
    }

    // mgigli 20180614 - Setto i cookie per ricordare le date all'invio del motorino di ricerca

    $('#form-prenotazione form [type="submit"]').click(function(e) {
        e.preventDefault();

        createCookie('lampoDataArr', $('[name="arrivo"]').val(), 30);
        createCookie('lampoDataPar', $('[name="partenza"]').val(), 30);

        //console.log("Cookie creati");

        setTimeout(function() { $('#form-prenotazione form').submit(); }, 1000);
    });

    // mgigli 20180614 - Setto i campi data (formattati e hidden) con i valori dei cookie al caricamento delle pagine

    $(document).ready(function(){
        var cookieDataArr = readCookie('lampoDataArr');
        var cookieDataPar = readCookie('lampoDataPar');

        if ($('[name="datetimerange"]').length > 0 && cookieDataArr && cookieDataPar) {
            var cookieDataArrFormat = cookieDataArr.substr(6,2) + '/' + cookieDataArr.substr(4,2) + '/' + cookieDataArr.substr(0,4);
            var cookieDataParFormat = cookieDataPar.substr(6,2) + '/' + cookieDataPar.substr(4,2) + '/' + cookieDataPar.substr(0,4);

            $('[name="arrivo"]').val(cookieDataArr);
            $('[name="partenza"]').val(cookieDataPar);

            $('[name="datetimerange"]').data('daterangepicker').setStartDate(cookieDataArrFormat);
            $('[name="datetimerange"]').data('daterangepicker').setEndDate(cookieDataParFormat);

            //console.log("Cookie settati");
        }
    });

    // mgigli - Test per scrollarea al posto del checkbox privacy nella form Newsletter
    // Checka la privacy (nascosta) quando scrollo fino in fondo al testo
    /*
    $('.wpcf7-form-control-wrap.privacy input, .wpcf7-form-control-wrap.privacy label').hide(); // Eventualmente da mettere nel css
    $('#privacy-scrollarea').scroll(function(){
        if ($(this)[0].scrollHeight - $(this).scrollTop() === $(this).outerHeight()) {
            //console.log('sono in fondo');
            $('input[type="checkbox"]#privacy').prop('checked', true);
        };
    });
    */

    // mgigli 20220223 - Tracciamento click download cataloghi GA4
    // rif. https://docs.google.com/spreadsheets/d/19M24bYbdBJOB4Eku39IbFLGV_AxI30pjWGZDPDucJmw/edit#gid=544312610
    $('.catalogo a').click(function(e){
		e.preventDefault();
        var myhref = $(this).attr("href");
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'download_catalogue',
            'catalogue_name': $(this).find('span').text(),
        });
		setTimeout(function() { window.location.href = myhref }, 1000);
	});

    // mgigli 20240312 - Tracciamento click generico con GTM
    // Nota: aggiungere l'attributo data-gtm-event="evento_da_tracciare" ai link da tracciare
    $('a[data-gtm-event]').click(function(e){
		e.preventDefault();
        var myhref = $(this).attr('href');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': $(this).attr('data-gtm-event'),
        });
		setTimeout(function() { window.location.href = myhref }, 1000);
	});

    $(document).ready(function(){
        var currLang = $('html').attr('lang').substr(0, 2);
        
        var accomodations = [{
            value: "Bibione",
            data: {
                locationCode: "BI",
                category: "Località",
                imageUrl: "http://lampo.mentine.net/wp-content/themes/lampo/dist/images/ico-pin.png",
                avantio: false,
            },
        },
        {
            value: "Caorle",
            data: {
                locationCode: "81",
                category: "Località",
                imageUrl: "http://lampo.mentine.net/wp-content/themes/lampo/dist/images/ico-pin.png",
                avantio: false,
            }
        },
    
        {
            value: "Porto Santa Margherita",
            data: {
                locationCode: "31",
                category: "Località",
                imageUrl: "http://lampo.mentine.net/wp-content/themes/lampo/dist/images/ico-pin.png",
                avantio: true,
                avantioBookingUrl: {
                    "it": "https://reservationpsm.lampo.it",
                    "en": "https://reservationpsm.lampo.it/en/rentals/holidays-rentals-rentals-d0/",
                    "de": "https://reservationpsm.lampo.it/de/vermietung/zu-mieten-vermietungen-d0/",
                },
            }
        },
    
        {
            value: "Caorle - Lido Altanea",
            data: {
                locationCode: "CA",
                category: "Località",
                imageUrl: "http://lampo.mentine.net/wp-content/themes/lampo/dist/images/ico-pin.png",
                avantio: false,
            }
        },
        {
            value: "Lido di Jesolo",
            data: {
                locationCode: "11",
                category: "Località",
                imageUrl: "http://lampo.mentine.net/wp-content/themes/lampo/dist/images/ico-pin.png",
                avantio: false,
            }
        },
        {
            value: "Villaggio Lido del Sole",
            data: {
                category: "Strutture",
                imageUrl: "http://lampo.mentine.net/wp-content/themes/lampo/dist/images/ico-hotel.png",
                locationName: "Bibione",
                premiumImgUrl: "",
                avantio: true,
                avantioBookingUrl: {
                    "it": "https://reservationvlds.lampo.it",
                    "en": "https://reservationvlds.lampo.it/en/rentals/holidays-rentals-rentals-d0/",
                    "de": "https://reservationvlds.lampo.it/de/vermietung/zu-mieten-vermietungen-d0/",
                },
            }
        },
        {
            value: "Summertime",
            data: {
                category: "Strutture",
                imageUrl: "http://lampo.mentine.net/wp-content/themes/lampo/dist/images/ico-hotel.png",
                locationName: "Bibione",
                premiumImgUrl: "http://lampo.mentine.net/wp-content/themes/lampo/dist/images/ico-star.png",
                avantio: true,
                avantioBookingUrl: {
                    "it": "https://reservationstfr.lampo.it",
                    "en": "https://reservationstfr.lampo.it/en/rentals/holidays-rentals-rentals-d0/",
                    "de": "https://reservationstfr.lampo.it/de/vermietung/zu-mieten-vermietungen-d0/",
                },
            }
        },
        {
            value: "Pini Village",
            data: {
                category: "Strutture",
                imageUrl: "http://lampo.mentine.net/wp-content/themes/lampo/dist/images/ico-hotel.png",
                locationName: "Lido Altanea",
                premiumImgUrl: "http://lampo.mentine.net/wp-content/themes/lampo/dist/images/ico-star.png",
                avantio: true,
                avantioBookingUrl: {
                    "it": "https://reservationpini.lampo.it",
                    "en": "https://reservationpini.lampo.it/en/rentals/holidays-rentals-rentals-d0/",
                    "de": "https://reservationpini.lampo.it/de/vermietung/zu-mieten-vermietungen-d0/",
                },
            }
        },
        {
            // Legenda
            value: "",
            data: {
                category: "<img src='http://lampo.mentine.net/wp-content/themes/lampo/dist/images/ico-star.png' /><div>Strutture premium <span>Servizi inclusi e massimo comfort</span></div>",
                locationName: "",
                imageUrl: "",
                
            }
        },
        ];

        var accomodationFirstClick = true;

        function handleAccomodationEvent() {
            if ($(this).val() != '') {
                $(this).val('');
                $('#accomodation').autocomplete().enable();
                $('#accomodation').change();
            }
            else {
                if (! accomodationFirstClick) {
                    $('.autocomplete-suggestions').toggle();
                }
                if (accomodationFirstClick) accomodationFirstClick = false;
            }
        }

        //$('#accomodation').click(handleAccomodationEvent);
        $('#accomodation').focus(handleAccomodationEvent);
    
        // Rif. https://github.com/devbridge/jQuery-Autocomplete
        $('#accomodation').autocomplete({
            lookup: accomodations,
            minChars: 0,
            forceFixPosition: true,
            groupBy: 'category',
            appendTo: $("#accomodation").parents('.inputDropdownHead'),
            noCache: true,
            //preserveInput: false,
            formatResult: function (suggestion) {
                let locationName = typeof suggestion.data.locationName !== "undefined" ? '<span>' + suggestion.data.locationName + '</span>' : ''; 

                let img = typeof suggestion.data.imageUrl!== "undefined" ? suggestion.data.imageUrl: ''; 
                if (img) img = '<img src="' + img + '" alt="" /> ';

                let premiumImg = typeof suggestion.data.premiumImgUrl !== "undefined" ? suggestion.data.premiumImgUrl : ''; 
                if (premiumImg) premiumImg = '<div><img src="' + premiumImg + '" alt="" /> </div>';

                let locationCode = typeof suggestion.data.locationCode !== "undefined" ? suggestion.data.locationCode : ''; 
                if (locationCode) locationCode = ' data-loc-code="' + locationCode + '"';

                return '<div' + locationCode + '>' + img + '<div> ' + suggestion.value + locationName + ' </div> </div> ' + premiumImg;
            },
            onSelect: function (suggestion) {
                $('#accomodation').autocomplete().disable();
                
                // Strutture su Avantio: mando al suo booking (che non legge i parametri GET localita', data e persone)
                if (suggestion.data.avantio) {
                    $('.hide-if-avantio').hide();
                    $('.show-if-avantio').show();
                    $('.form-prenota').attr('action', suggestion.data.avantioBookingUrl[currLang]);
                    //$('.form-prenota').attr('action', $('[name="avantio_booking_link"]').val());
                }
                // Strutture non Avantio: mando al booking di lampo
                else {
                    $('.hide-if-avantio').show();
                    $('.show-if-avantio').hide();
                    $('.form-prenota').attr('action', $('[name="lampo_booking_link"]').val());
                    $('.form-prenota [name="localita"]').val(suggestion.data.locationCode);
                }
            }
        });

        let currLocalita = $('.form-prenota [name="curr_localita"]').val();
        if (currLocalita) {
            $('#accomodation').trigger('focus.autocomplete').trigger('focus');     
            $('[data-loc-code="' + currLocalita + '"]').parent().click();
            $('#accomodation').trigger('blur');
        }
    });

})(jQuery); // Fully reference jQuery after this point.
